import {
  Box,
  Button,
  Heading,
  Stack,
  Flex,
  Link,
  Spacer,
  Text,
  UnorderedList,
  ListItem
} from "@chakra-ui/react";
import { Link as RouterLink, useParams } from "react-router-dom";

import LoadingTitle from "../components/LoadingTitle";
import RESULT_CARD_LOOKUP from "../data/resultCardLookup";

function LoadingView() {
  const {
    carReg,
    carPrice,
    depositValue,
    carMileage,
    budget,
    loanLength,
    firstName
  } = useParams();

  const sortedFinalResults = JSON.parse(
    localStorage.getItem("sortedFinalResults")
  );

  return (
    <Stack spacing={6} py={2} px={4} flex="1 0 auto" minHeight="500px">
      <Heading size="md" width="80%" color="#2969B0">
        {firstName}, please check you’re happy with these details.
      </Heading>

      <Stack px={6} py={4} background="#EFF0F6" width="95%">
        <Flex borderBottom="1px solid #ccc" pb={3} mb={2}>
          <Heading size="sm">Your details</Heading>
          <Spacer />
          <Link textDecoration="underline" color="#2969B0">
            Edit
          </Link>
        </Flex>
        <Flex>
          <Text>Car registration:</Text>
          <Spacer />
          <Text fontWeight="bold" style={{ textTransform: "uppercase" }}>
            {carReg}
          </Text>
        </Flex>
        <Flex>
          <Text>Car value:</Text>
          <Spacer />
          <Text fontWeight="bold">£{carPrice}</Text>
        </Flex>
        <Flex>
          <Text>Deposit amount:</Text>
          <Spacer />
          <Text fontWeight="bold">£{depositValue}</Text>
        </Flex>
        <Flex>
          <Text>Annual mileage:</Text>
          <Spacer />
          <Text fontWeight="bold">{carMileage} miles</Text>
        </Flex>
        <Flex>
          <Text>Monthly budget</Text>
          <Spacer />
          <Text fontWeight="bold">£{budget}</Text>
        </Flex>
        <Flex>
          <Text>Finance length</Text>
          <Spacer />
          <Text fontWeight="bold">{loanLength} years</Text>
        </Flex>
      </Stack>
      <Heading size="sm" lineHeight="1.6" width="85%">
        <LoadingTitle
          sortedFinalResults={sortedFinalResults}
          resultCardLookup={RESULT_CARD_LOOKUP}
        />
      </Heading>
      <Box width="85%">
        <Text fontSize="14px">
          We appreciate that you may want to think over your options and the
          deals we’ve found. So, to help, once we’ve got your results, we’ll
          email you an easy-to-read information pack containing:
        </Text>
        <UnorderedList fontSize="14px" py={2} px={2}>
          <ListItem>Your results</ListItem>
          <ListItem>What the deals mean</ListItem>
          <ListItem>Why the deals match your needs</ListItem>
        </UnorderedList>
        <Text fontSize="14px">
          So that you’ve got all the information to hand when talking with
          dealers or reviewing your choices, we’ll email you an easy-to-read
          information pack. That way you’ll have all the facts, insights and
          results to hand.
        </Text>
      </Box>
      <Box>
        <Link
          as={RouterLink}
          to={`/results/${carReg}/${carPrice}/${depositValue}/${carMileage}/${budget}/${loanLength}/${firstName}`}
        >
          <Button size="lg" colorScheme="blue">
            Show my results
          </Button>
        </Link>
      </Box>
    </Stack>
  );
}

export default LoadingView;
